(function ($, undefined) {
    var sm = window.sm = window.sm || {};

    if (typeof sm.portal === "undefined") {
        $.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        $.extend(sm.portal, { vm: {} });
    }

    // PRIMARY MODEL
    // This model represents a Mailing Address and our standard Form Templates.
    // This may be referenced by a property another view model.
    function MailingAddressViewModel(_fromMyProfile) {

        // Self-Identification
        var self = this;
        self.hideDoNotContact = ko.observable(false);
        self.hideEffectiveLabelDisplay = ko.observable(false);
        self.hideStreetSuffixID = ko.observable(false);

        self.BuildingNameText = ko.observable('MA_ALL_BuildingName');
        self.CityText = ko.observable('MA_ALL_City');
        self.MunicipalityText = ko.observable('MA_ALL_Municipality');
        self.PostalCodeText = ko.observable('MA_ALL_PostalCode');
        self.PermanentMailingAddressFields = ko.observable(false);
        this.HideCoreFieldsMailingAddress = ko.observable(false);
        this.CountriesUpdated = ko.observable('');
        this.UpdatedAddressField = ko.observable('');
        this.PermanentAddressText = ko.observable('');
        this.HidePermanentAddText =  ko.observable(false);
        
        var data = {
            self: self,
            fromMyProfile: _fromMyProfile
        }

        this.IsAPASApplicant = ko.observable();

        sm.portal.vm.custom.callCustomization('MyProfileCustom', data)
        sm.portal.vm.custom.setCustomLocalizeKey(self);

        // Loading Methods
        this.LoadModel = function (container, isMobileReady) {

            if (sm.portal.utility.isNullOrEmpty(isMobileReady)) {
                isMobileReady = false;
            }
            this.IsAPASApplicant(container.Payload.IsAPASApplicant);

            // List Data
            if (container.Payload.ListData) {
                if (!sm.portal.utility.isNullOrEmpty(container.Payload.ListData.AllCountry)) {
                    ko.mapping.fromJS(container.Payload.ListData.AllCountry, {}, this.Countries);
                    sm.portal.vm.custom.callCustomization('UpdateAllCountryList', container.Payload.ListData.AllCountry);
                }
                if (!sm.portal.utility.isNullOrEmpty(container.Payload.ListData.MailingAddressAssociations)) {
                    ko.mapping.fromJS(container.Payload.ListData.MailingAddressAssociations, {}, this.Associations);
                }
                if (!sm.portal.utility.isNullOrEmpty(container.Payload.ListData.DoNotContactReasons)) {
                    ko.mapping.fromJS(container.Payload.ListData.DoNotContactReasons, {}, this.DoNotContactReasons);
                }
                if (!sm.portal.utility.isNullOrEmpty(container.Payload.ListData.GoverningDistrict)) {
                    ko.mapping.fromJS(container.Payload.ListData.GoverningDistrict, {}, this.GoverningDistrict);
                }
                if (!sm.portal.utility.isNullOrEmpty(container.Payload.ListData.StreetSuffix)) {
                    ko.mapping.fromJS(container.Payload.ListData.StreetSuffix, {}, this.StreetSuffix);
                }
            }

            // System Country
            if (!sm.portal.utility.isNullOrEmpty(container.Payload.SystemCountry)) {
                this.SystemCountry(ko.mapping.fromJS(container.Payload.SystemCountry));
                var cusData = {
                    self: self,
                    container: container
                } 
                sm.portal.vm.custom.callCustomization('SetCountryCode',cusData);
            }

            var customData = {
                self: self,
                container: container
            }
            sm.portal.vm.custom.callCustomization('AllCountryTemplates', customData);
            this.UpdateAddressTemplates(container);

            // Mobile Flag
            this.IsMobileReady(isMobileReady);
        };

        sm.portal.vm.custom.callCustomization('SetType',self);

        this.UpdateAddressTemplates = function(container){
            if (!sm.portal.utility.isNullOrEmpty(container.Payload.AllCountryTemplates)) {
                ko.mapping.fromJS(container.Payload.AllCountryTemplates, {}, this.AllCountryTemplates);
            }
            if (!sm.portal.utility.isNullOrEmpty(container.Payload.GoverningDistrict)) {
                var convertedGoverningDistrictData = container.Payload.GoverningDistrict.map(function(item) {
                    return { Text: item.Description, Value: item.ID, FilterField1Name: 'CountryID', FilterField1Value: item.CountryID };
                });
                ko.mapping.fromJS(convertedGoverningDistrictData, {}, this.GoverningDistrict);
            }
            if (!sm.portal.utility.isNullOrEmpty(container.Payload.StreetSuffix)) {
                var convertedStreetSuffixData = container.Payload.StreetSuffix.map(function(item) {
                    return { Text: item.Name, Value: item.ID, FilterField1Name: 'CountryID', FilterField1Value: item.CountryID };
                });
                ko.mapping.fromJS(convertedStreetSuffixData, {}, this.StreetSuffix);
            }
        };

        this.UpdateAddressTemplatesAjax = function (data, event) {
            // Call Api for new options
            if (event.originalEvent) {
                if (!sm.portal.utility.isNullOrEmpty(self.SelectedCountryID())) {
                    $.blockUI();

                    var url = encodeURI(_baseApiUri + sm.portal.utility.formatString('api/StudentPortal/CountryTemplates?countryId={0}', self.SelectedCountryID()));
                    var defaultTemplate = false;

                    sm.portal.utility.AjaxGet(
                        url,
                        onSuccess = function (data, textStatus, jqXHR) {
                            self.UpdateAddressTemplates(data);

                            var initialData = {
                                availableTemplates: self.AvailableTemplates,
                                selectedTemplateID: self.SelectedTemplateID,
                                previousSelectedTemplateID: self.PreviousSelectedTemplateID
                            }
                            if (self.PreviousSelectedTemplateID == undefined && self.SelectedTemplateID()) {
                                self.PreviousSelectedTemplateID = self.SelectedTemplateID();
                            }
                            else {
                                if (self.AvailableTemplates()) {
                                    self.AvailableTemplates().forEach(function (element) {
                                        if (element.DefaultSiteTemplate() && element.DefaultCountryTemplate() && element.IsObsolete() == false) {
                                            self.SelectedTemplateID(element.ID());

                                            defaultTemplate = true;

                                        }
                                        else if (element.BusinessMeaningName() == "MailAddressTemplate.AllFields" && !element.IsObsolete() && !defaultTemplate ) {

                                            self.SelectedTemplateID(element.ID());
                                            defaultTemplate = true;
                                        }
                                        else if (element.BusinessMeaningName() == "MailAddressTemplate.Simple" && !element.IsObsolete() && !defaultTemplate) {
                                            self.SelectedTemplateID(element.ID());
                                        }
                                    });

                                }
                                self.PreviousSelectedTemplateID = self.SelectedTemplateID();
                            }

                            sm.portal.vm.custom.callCustomization('UpdateAddressFields', initialData);
                            
                            var customInitData = {
                                self: self,
                                data: data
                            }
                            sm.portal.vm.custom.callCustomization('UpdateMailingTemplateID', customInitData);
                            sm.portal.vm.custom.callCustomization('SetCountryCode', customInitData);
                        },
                        OnError = function (jqXHR, exception) {
                            sm.portal.page.application.modelErrorHandler(self, jqXHR);
                        },
                        complete = function (jqXhr, textStatus) {
                            if (event && event.target) {
                                event.target.focus();
                            }
                        }
                    );
                    $.unblockUI();
                }
            }
        };

        this.LoadAddressModel = function (address) {
            if (!address || !address.AssociationIDs) {
                if (this.me) {
                    address = this.me;
                }
            }
            this.me = address;
            // Base Properties
            this.AddressID(address.ID);
            this.AddressGID(address.GID);

            this.AddressUnitNumber(address.UnitNumber);
            this.AddressFloor(address.Floor);
            this.AddressBuildingName(address.BuildingName);
            this.AddressStreetNumber(address.StreetNumber);
            this.AddressStreetAddress(address.StreetAddress);
            this.AddressStreetName(address.StreetName);
            this.AddressStreetDirection(address.StreetDirection);
            this.AddressStreetSuffixName(address.StreetSuffixName);
            this.AddressPostOfficeBoxNumber(address.PostOfficeBoxNumber);
            this.AddressMunicipality(address.Municipality);
            this.AddressStreetSuffixID(address.StreetSuffixID);
            this.AddressCity(address.City);
            this.AddressCounty(address.County);
            this.AddressCareOf(address.CareOf);
            this.AddressMiscellaneous1(address.Miscellaneous1);
            this.AddressMiscellaneous2(address.Miscellaneous2);
            this.AddressMiscellaneous3(address.Miscellaneous3);
            this.AddressAddressLine1(address.Address1);
            this.AddressAddressLine2(address.Address2);
            this.AddressAddressLine3(address.Address3);
            this.AddressPostalCode(address.PostalCode);

            this.AddressCountryID(address.CountryID);
            this.AddressTemplateID(address.MailingAddressTemplateID);

            var customDataAddressModel = {
                self: self,
                address: address
            }

            sm.portal.vm.custom.callCustomization('AddressModelAdditionalProps',customDataAddressModel)
        
            if (!sm.portal.utility.isNullOrEmpty(address.StateID))
                this.AddressGoverningDistrictID(address.StateID);
            else
                this.AddressGoverningDistrictName(address.GoverningDistrictName);

            var cusData = {
                self: self,
                address: address
            }
            sm.portal.vm.custom.callCustomization('AddressHTMLVal', cusData, function(){
                var encodedAddress = address.HTMLValue;
                if (!sm.portal.utility.isNullOrEmpty(encodedAddress)) {
                    self.AddressHtmlValue(encodedAddress.replace(/&lt;/g, '<').replace(/&gt;/g, '>'));
                } else {
                    self.AddressHtmlValue('');
                }
            })
            this.AddressTextValue(address.TextValue);

            this.AssociationIDs.removeAll();
            for (var i = 0; i < address.AssociationIDs.length; i++) {
                this.AssociationIDs.push(address.AssociationIDs[i].toString());
            }

            this.AssociationNames.removeAll();
            for (var i = 0; i < address.AssociationNames.length; i++) {
                this.AssociationNames.push(address.AssociationNames[i]);
            }

            var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
            var mailingAddressEffectiveFrom = address.EffectiveFrom ? moment(address.EffectiveFrom).format(dateFormat) : '';
            var mailingAddressEffectiveTo = address.EffectiveTo ? moment(address.EffectiveTo).format(dateFormat) : '';

            this.EffectiveFrom(mailingAddressEffectiveFrom);
            this.EffectiveTo(mailingAddressEffectiveTo);
            this.DoNotContact(address.DoNotContact);
            this.NoContactReasonID(address.NoContactReasonID);
            var customData = {
                self: self,
                address: address
            }
            var eventData = {
                originalEvent: true
            }
            if (this.AddressCountryID()) {
                this.SelectedCountryID(this.AddressCountryID());
                this.UpdateAddressTemplatesAjax(null, eventData);

            }
            sm.portal.vm.custom.callCustomization('UpdateCountryCode', customData);
        };

        this.LoadAddressModelFromAddressModel = function (address) {

            // Base Properties
            this.AddressID(address.AddressID());
            this.AddressGID(address.AddressGID());

            // These are named exactly like the types with addres at the start
            this.AddressUnitNumber(address.AddressUnitNumber());
            this.AddressFloor(address.AddressFloor());
            this.AddressBuildingName(address.AddressBuildingName());
            this.AddressStreetNumber(address.AddressStreetNumber());
            this.AddressStreetAddress(address.AddressStreetAddress());
            this.AddressStreetName(address.AddressStreetName());
            this.AddressStreetDirection(address.AddressStreetDirection());
            this.AddressStreetSuffixName(address.AddressStreetSuffixName());
            this.AddressPostOfficeBoxNumber(address.AddressPostOfficeBoxNumber());
            this.AddressMunicipality(address.AddressMunicipality());
            this.AddressGoverningDistrictName(address.AddressGoverningDistrictName());
            this.AddressStreetSuffixID(address.AddressStreetSuffixID());
            this.AddressCity(address.AddressCity());
            this.AddressCounty(address.AddressCounty());
            this.AddressCareOf(address.AddressCareOf());
            this.AddressMiscellaneous1(address.AddressMiscellaneous1());
            this.AddressMiscellaneous2(address.AddressMiscellaneous2());
            this.AddressMiscellaneous3(address.AddressMiscellaneous3());
            this.AddressPostalCode(address.AddressPostalCode());
            this.AddressCountryID(address.AddressCountryID());
            this.AddressTemplateID(address.AddressTemplateID());
            this.AddressAddressLine1(address.AddressAddressLine1());
            this.AddressAddressLine2(address.AddressAddressLine2());
            this.AddressAddressLine3(address.AddressAddressLine3());

            var data = {
                self:self,
                address:address
            }

            sm.portal.vm.custom.callCustomization('UpdateLoadAddressModelProps',data);

            var encodedAddress = address.AddressHtmlValue();
            if (!sm.portal.utility.isNullOrEmpty(encodedAddress)) {
                this.AddressHtmlValue(encodedAddress.replace(/&lt;/g, '<').replace(/&gt;/g, '>'));
            } else {
                this.AddressHtmlValue('');
            }
            this.AddressTextValue(address.AddressTextValue);

            this.AssociationIDs.removeAll();
            for (var i = 0; i < address.AssociationIDs().length; i++) {
                this.AssociationIDs.push(address.AssociationIDs()[i].toString());
            }

            this.AssociationNames.removeAll();
            for (var i = 0; i < address.AssociationNames().length; i++) {
                this.AssociationNames.push(address.AssociationNames()[i]);
            }

            var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
            var mailingAddressEffectiveFrom = address.EffectiveFrom ? moment(address.EffectiveFrom).format(dateFormat) : '';
            var mailingAddressEffectiveTo = address.EffectiveTo ? moment(address.EffectiveTo).format(dateFormat) : '';

            this.EffectiveFrom(mailingAddressEffectiveFrom);
            this.EffectiveTo(mailingAddressEffectiveTo);
            this.DoNotContact(address.DoNotContact());
            this.SelectedCountryID(address.SelectedCountryID());
            this.SelectedTemplateID(address.SelectedTemplateID());

            this.AddressGoverningDistrictID(address.AddressGoverningDistrictID());
            this.DoNotContact(address.DoNotContact);
            this.NoContactReasonID(address.NoContactReasonID);
        };

        this.setType = function (type) {
            self.Type(type);
        };

        this.LoadAddressForPayment = function (address) {

            var encodedAddress = address.AddressHtmlValue();
            if (!sm.portal.utility.isNullOrEmpty(encodedAddress)) {
                this.AddressHtmlValue(encodedAddress.replace(/&lt;/g, '<').replace(/&gt;/g, '>'));
            } else {
                this.AddressHtmlValue('');
            }
            this.AddressTextValue(address.AddressTextValue);
        };

        // Primary Address Properties
        this.AddressID = ko.observable();
        this.AddressGID = ko.observable();
        this.Type = ko.observable();

        // Field Mapped with their name as Address and the Type Name
        this.AddressCountryID = ko.validatedObservable();
        this.AddressUnitNumber = ko.validatedObservable();
        this.AddressFloor = ko.validatedObservable();
        this.AddressBuildingName = ko.validatedObservable();
        this.AddressStreetNumber = ko.validatedObservable();
        this.AddressStreetAddress = ko.validatedObservable();
        this.AddressStreetName = ko.validatedObservable();
        this.AddressStreetDirection = ko.validatedObservable();
        this.AddressStreetSuffixName = ko.validatedObservable();
        this.AddressPostOfficeBoxNumber = ko.validatedObservable();
        this.AddressMunicipality = ko.validatedObservable();
        this.AddressStreetSuffixID = ko.validatedObservable();
        this.AddressGoverningDistrictName = ko.validatedObservable();
        this.AddressGoverningDistrictID = ko.validatedObservable(); // Also known as STATEID
        this.AddressCity = ko.validatedObservable();
        this.AddressCounty = ko.validatedObservable();
        this.AddressCareOf = ko.validatedObservable();
        this.AddressMiscellaneous1 = ko.validatedObservable();
        this.AddressMiscellaneous2 = ko.validatedObservable();
        this.AddressMiscellaneous3 = ko.validatedObservable();
        this.AddressPostalCode = ko.validatedObservable();
        this.AddressAddressLine1 = ko.validatedObservable();
        this.AddressAddressLine2 = ko.validatedObservable();
        this.AddressAddressLine3 = ko.validatedObservable();
        this.FullObjectValidation = ko.observable(true);

        sm.portal.vm.custom.callCustomization('UpdateFieldMapAddressprops',self);

        this.AddressHtmlValue = ko.observable();
        this.AddressTextValue = ko.observable();
        this.AddressTemplateID = ko.observable();
        this.AssociationIDs = ko.observableArray();
        this.AssociationNames = ko.observableArray();
        this.useMailingAddress = ko.observable('checked');

        // Effective Dates
        this.EffectiveFrom = ko.observable();
        this.EffectiveTo = ko.observable();
        this.DoNotContact = ko.observable();
        this.NoContactReasonID = ko.observable();
        this.DoNotContactReasons = ko.observableArray([new smapi.access.ListItemModel()]);

        this.EffectiveLabelDisplay = ko.computed(function () {

            if (sm.portal.utility.isNullOrEmpty(this.EffectiveFrom()) && !sm.portal.utility.isNullOrEmpty(this.EffectiveTo())) {
                return sm.portal.utility.getResourceValue('EffectiveTill');
            }
            return sm.portal.utility.getResourceValue('EffectiveFrom');

        }, this);
        this.EffectiveDisplay = ko.computed(function () {
            var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();

            if (!sm.portal.utility.isNullOrEmpty(this.EffectiveFrom()) && !sm.portal.utility.isNullOrEmpty(this.EffectiveTo())) {
                // Return full FROM..TO.. string
                return this.EffectiveFrom() + " to " + this.EffectiveTo();
            } else if (!sm.portal.utility.isNullOrEmpty(this.EffectiveFrom()) && sm.portal.utility.isNullOrEmpty(this.EffectiveTo())) {
                // Return FROM...
                return this.EffectiveFrom();
            } else if (sm.portal.utility.isNullOrEmpty(this.EffectiveFrom()) && !sm.portal.utility.isNullOrEmpty(this.EffectiveTo())) {
                return this.EffectiveTo();
            }
            return "";

        }, this);

        this.DoNotContactAsYesNo = ko.computed(function () {
            if (this.DoNotContact()) {
                return sm.portal.utility.getResourceValue('Yes');
            }
            return sm.portal.utility.getResourceValue('No');
        }, this);
        this.AssociationDisplay = ko.computed(function () {

            var display = '';
            for (var i = 0; i < this.AssociationNames().length; i++) {
                if (display == '') {
                    display = this.AssociationNames()[i];
                } else {
                    display += ', ' + this.AssociationNames()[i];
                }
            }
            return display;

        }, this);

        // Mailing Address List Values
        this.GoverningDistrict = ko.observableArray([new smapi.access.ListItemModel()]);
        this.StreetSuffix = ko.observableArray([new smapi.access.ListItemModel()]);
        this.Countries = ko.observableArray([new smapi.access.ListItemModel()]);
        this.Associations = ko.observableArray([new smapi.access.ListItemModel()]);
        sm.portal.vm.custom.callCustomization('CountriesReorderedComputed', self);

        // The Current System Country
        this.SystemCountry = ko.observable(new sm.portal.vm.AddressTemplateCountryViewModel());

        // Mixed Country and Template List
        this.AllCountryTemplates = ko.observableArray([new sm.portal.vm.AddressTemplateCountryViewModel()]);
        this.Fields = ko.observableArray([]);
        // Current Selected Options
        this.IsMobileReady = ko.observable();
        this.SelectedCountryID = ko.validatedObservable();
        this.SelectedCountryGID = ko.validatedObservable();
        this.SelectedTemplateID = ko.validatedObservable();
        this.SelectedTemplate = ko.observable();
        this.PreviousSelectedTemplateID = undefined;
        this.SelectedCountryText = ko.observable();

        sm.portal.vm.custom.callCustomization('UpdateUKProperty', self);

        this.AvailableTemplates = ko.computed(function () {
            var results;// = null;
            if (this.SelectedCountryID() == undefined || this.SelectedCountryID() == null) {
                results = null;
            } else {
                var selectedCountryID = this.SelectedCountryID();
                for (var i = 0; i < this.AllCountryTemplates().length; i++) {
                    if (this.AllCountryTemplates()[i].ID() == selectedCountryID) {
                        results = this.AllCountryTemplates()[i].Templates();
                        break;
                    }
                }
            }
            if(!sm.portal.utility.isUKFeatureEnabled()){
                var res = sm.portal.vm.custom.callCustomization('UpdateAvailableTemplates', results);
                if (!sm.portal.utility.isNullOrEmpty(res)) {
                    results = res;
                }
            }
            var CutomParams = {
                self: self,
                results: results
            }
            sm.portal.vm.custom.callCustomization('UpdateglobalIntuitiveLookup', CutomParams);
            return results;
        }, this);

        this.AvailableGoverningDistricts = ko.computed(function () {

            var results = Array();
            if (sm.portal.utility.isNullOrEmpty(this.SelectedCountryID())) {
                results = null;
            } else {
                var matchID = this.SelectedCountryID();
                for (var i = 0; i < this.GoverningDistrict().length; i++) {
                    var currGovDistrict = this.GoverningDistrict()[i];
                    if (!sm.portal.utility.isNullOrEmpty(currGovDistrict)) {
                        if (currGovDistrict.FilterField1Value() == matchID) {
                            results.push(currGovDistrict);
                        }
                    }
                }
            }

            return results;

        }, this);
        this.AvailableStreetSuffixes = ko.computed(function () {

            var results = Array();
            if (sm.portal.utility.isNullOrEmpty(this.SelectedCountryID())) {
                results = null;
            } else {

                var matchID = this.SelectedCountryID();
                for (var i = 0; i < this.StreetSuffix().length; i++) {
                    var currSuffix = this.StreetSuffix()[i];
                    if (!sm.portal.utility.isNullOrEmpty(currSuffix)) {
                        if (currSuffix.FilterField1Value() == matchID) {
                            results.push(currSuffix);
                        }
                    }
                }
            }

            return results;

        }, this);
        this.SelectedTemplateBMN = ko.computed(function () {
            var BMN = 'NoTemplate';

            if (this.SelectedTemplate() != undefined && this.SelectedTemplate() != null) {
                if (this.SelectedTemplate().BusinessMeaningName().length > 0) {
                    BMN = this.SelectedTemplate().BusinessMeaningName();
                }
            }

            return BMN;
        }, this);

        // Subscriptions
        this.SelectedTemplateID.subscribe(function (newValue) {
            var newValueUpdated = sm.portal.vm.custom.callCustomization('UpdateSelectedTemplateIDSubscribe', newValue);
            if(!sm.portal.utility.isNullOrEmpty(newValueUpdated)){
                newValue = newValueUpdated;
            }
            this.LoadMailingTemplate(this.SelectedCountryID(), newValue);
        }, this);
        this.SelectedCountryID.subscribe(function (newValue) {

            $.each(this.Countries(), function (k, country) {
                if (country.ID() == newValue) {
                    self.SelectedCountryText(country.Text());
                    var customParams = {
                        self: self,
                        newValue: newValue
                    }
                    sm.portal.vm.custom.callCustomization('UpdateLoadMailingnewValue', customParams);
                    return;
                }
            });

            this.LoadMailingTemplate(newValue, this.SelectedTemplateID());
        }, this);
        this.SelectedCountryID.subscribe(function (oldValue) {
            this.PreviousSelectedTemplateID = this.SelectedTemplateID();
        }, this, "beforeChange");

        // Functions
        this.LoadMailingTemplate = function (countryID, templateID) {

            var countries = null;
            var country = null;
            var templates = null;

            var customReturn  = sm.portal.vm.custom.callCustomization('UpdateLoadMailingTemplate', self, function(){
                return false;
            });

            if (customReturn) return;
        
            if (this.AllCountryTemplates().length > 0) {

                countries = this.AllCountryTemplates();

                this.AllCountryTemplates().forEach(function (element) {
                    if (element.ID() == countryID) {
                        country = element;
                    }
                });

                if (country != null && country.Templates().length > 0) {
                    self.SelectedCountryGID(country.GID());
                    // Match Template (could have multiple matches - but shouldn't)
                    templates = $.grep(country.Templates(), function (a) {
                        return a.ID() == templateID;
                    });
                }

                if (templates != null && templates.length > 0) {
                    // Save Template Data
                    this.SelectedTemplate(templates[0]);
                    this.Fields = templates[0];
                    var customData = {
                        self: self,
                        templates: templates
                    }
                    sm.portal.vm.custom.callCustomization('UpdateSelectedTemplateID', customData)
                    this.initAddressLookup();
                }
                else {
                    // Set blank template to force the Display to hide the fields
                    // and show the "You must select a tempalte and country" message
                    this.SelectedTemplate(null);
                }
            }
        };

        this.initAddressLookup = function () {
            var that = this;
            if (!that.SelectedTemplate()) {
                return;
            }
            // attach an autocomplete to the Trigger fields input
            $('.field.mailingAddress p[data-is-lookup-trigger-field]').each(function () {
               // if (ko.dataFor(this) !== that) return;
                var triggerFieldInput = $(this).prevAll('input');
                triggerFieldInput.attr('placeholder', sm.portal.utility.getResourceValue('TypeToSearch'))
                var triggerBoundFieldName = triggerFieldInput.attr('id');
                var numberOfCharactersNeededToTriggerTheLookup = that.SelectedTemplate().LookupTriggerFieldsWithRequiredCharacters[triggerBoundFieldName];
                var mailingAddressTemplateIDForLookupUpdate = sm.portal.vm.custom.callCustomization('MailingAddressTemplateIDForLookupUpdate', self);
                var mailingAddressTemplateIDForLookup = that.SelectedTemplateID();
                if(!sm.portal.utility.isNullOrEmpty(mailingAddressTemplateIDForLookupUpdate)){
                    mailingAddressTemplateIDForLookup = mailingAddressTemplateIDForLookupUpdate;
                }
                $(triggerFieldInput).autocomplete({
                    delay: 0,
                    minLength: numberOfCharactersNeededToTriggerTheLookup,
                    source: function (request, response) {
                        var sourceUrl = _baseApiUri + 'api/MailingAddress/AddressLookup/?mailingAddressTemplateID=' + mailingAddressTemplateIDForLookup + "&triggerFieldName=" + triggerBoundFieldName + "&triggerValue=" + request.term + "&maxLabelLength=80";
                        $.ajax({
                            url: sourceUrl,
                            type: 'GET',
                            dataType: 'json',
                            contentType: 'application/json; charset=utf-8',
                            headers: {
                                "x-api-version": '1'
                            },
                            processData: false,
                            crossDomain: true,
                            xhrFields: {
                                withCredentials: true
                            },
                            success: function (data, textStatus, jqXHR) {
                                if (data.Status == "success" && data.Payload != undefined) {
                                    if (data.Payload.addressData != undefined && data.Payload.addressData.length > 0) {
                                        data.Payload.addressData.sort(function (a, b) { return (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0); });
                                        response(data.Payload.addressData);
                                    }
                                    else if (data.Payload.errorMessage != undefined && data.Payload.errorDetail != undefined) {
                                        console.log('Error in address lookup: ' + data.Payload.errorMessage);
                                        console.log('Detail of error in address lookup: ' + data.Payload.errorDetail);
                                    }
                                }
                                else {
                                    console.log('Error in getting address lookup, data.Status = ' + data.Status);
                                }
                            },
                            error: function (jqXHR, exception) {
                                viewModel.HandleError(exception);
                            }
                        });
                    },
                    select: function (event, ui) {
                        if (ui.item.Id != null && ui.item.Id != "") {
                            var sourceUrl = _baseApiUri + 'api/MailingAddress/IndividualAddressLookup/?mailingAddressTemplateID=' + mailingAddressTemplateIDForLookup + "&triggerFieldName=" + triggerBoundFieldName + "&id=" + ui.item.Id;
                            $.ajax({
                                url: sourceUrl,
                                type: 'GET',
                                dataType: 'json',
                                contentType: "application/json; charset=utf-8",
                                headers: {
                                    "x-api-version": '1'
                                },
                                processData: false,
                                crossDomain: true,
                                success: function (data, textStatus, jqXHR) {
                                    if (data.Status == "success" && data.Payload.addressData != undefined) {
                                        ui.item = data.Payload.addressData;
                                        for (fieldName in ui.item) {
                                            var fieldValue = ui.item[fieldName];
                                            if (fieldValue != undefined && that["Address" + fieldName] != undefined) {
                                                that["Address" + fieldName](fieldValue);
                                            }
                                        }
                                        return false;
                                    }
                                    else if (data.errorMessage != undefined && data.errorDetail != undefined) {
                                        console.log('Error in individual address lookup: ' + data.Payload.errorMessage);
                                        console.log('Detail of error in individual address lookup: ' + data.Payload.errorDetail);

                                    }
                                },
                                error: function (jqXHR, exception) {
                                    viewModel.HandleError(exception);
                                }
                            });
                        }
                       else if (ui.item.Sid != null && ui.item.Sid != "") {
                            var sourceUrl = _baseApiUri + 'api/MailingAddress/AddressLookupBySID/?mailingAddressTemplateID=' + mailingAddressTemplateIDForLookup + "&triggerFieldName=" + "Sid" + "&sid=" + ui.item.Sid;
                            $.ajax({
                                url: sourceUrl,
                                type: 'GET',
                                dataType: 'json',
                                contentType: "application/json; charset=utf-8",
                                headers: {
                                    "x-api-version": '1'
                                },
                                processData: false,
                                crossDomain: true,
                                success: function (data, textStatus, jqXHR) {
                                    self.AddressPostalCode('');
                                    if (data.Status == "success" && data.Payload.addressData != undefined) {
                                        ui.item = data.Payload.addressData;
                                        for (fieldName in ui.item) {
                                            var fieldValue = ui.item[fieldName];
                                            if (fieldValue != undefined && that["Address" + fieldName] != undefined) {
                                                that["Address" + fieldName](fieldValue);
                                            }
                                        }
                                        return false;
                                    }
                                    else if (data.errorMessage != undefined && data.errorDetail != undefined) {
                                        console.log('Error in individual address lookup: ' + data.Payload.errorMessage);
                                        console.log('Detail of error in individual address lookup: ' + data.Payload.errorDetail);

                                    }
                                },
                                error: function (jqXHR, exception) {
                                    viewModel.HandleError(exception);
                                }
                            });
                        }
                        else {
                            // update the other address fields from the selected Address Lookup item
                            for (fieldName in ui.item) {
                                var fieldValue = ui.item[fieldName];
                                if (fieldValue != undefined && that["Address" + fieldName] != undefined) {
                                    that["Address" + fieldName](fieldValue);
                                }
                            }
                            return false;
                        }
                    },
                    change: function (event, ui) {

                    },
                    focus: function (event, ui) {
                        // set tooltipLabel in title attribute to display tooltip
                        $(".ui-autocomplete > li").attr("title", ui.item.tooltipLabel);
                        return false;
                    }
                });
            });
        };

        this.FieldTypeRequiredForTemplate = function (BMN) {
            var required = false;
            if (this.SelectedTemplate() != undefined && this.SelectedTemplate() != null) {
                var fields = this.SelectedTemplate().Fields();
                if (fields != null && fields.length > 0) {
                    var field = jQuery.grep(fields, function (a) {
                        return a.FieldTypeBMN() == BMN;
                    });
                    if (field != null && field.length > 0) {
                        if (field[0].FieldIsRequired && field[0].FieldIsRequired()) {
                            required = true;
                        }
                    }
                }
            }
            return required;
        };
        this.ExtractATO = function () {

            var submitAddressObject = ko.mapping.toJS(this);

            var assocIDs = Array();
            for (var i = 0; i < submitAddressObject.AssociationIDs.length; i++) {
                assocIDs.push(submitAddressObject.AssociationIDs[i]);
            }

            var data = {
                UnitNumber: submitAddressObject.AddressUnitNumber,
                Floor: submitAddressObject.AddressFloor,
                BuildingName: submitAddressObject.AddressBuildingName,
                StreetNumber: submitAddressObject.AddressStreetNumber,
                StreetName: submitAddressObject.AddressStreetName,
                StreetAddress: submitAddressObject.AddressStreetAddress,
                StreetDirection: submitAddressObject.AddressStreetDirection,
                StreetSuffixName: submitAddressObject.AddressStreetSuffixName,
                PostOfficeBoxNumber: submitAddressObject.AddressPostOfficeBoxNumber,
                Municipality: submitAddressObject.AddressMunicipality,
                StreetSuffixID: submitAddressObject.AddressStreetSuffixID,
                GoverningDistrictName: submitAddressObject.AddressGoverningDistrictName,
                StateID: submitAddressObject.AddressGoverningDistrictID,
                City: submitAddressObject.AddressCity,
                County: submitAddressObject.AddressCounty,
                CareOf: submitAddressObject.AddressCareOf,
                PostalCode: submitAddressObject.AddressPostalCode,
                CountryID: submitAddressObject.SelectedCountryID,
                MailingAddressTemplateID: submitAddressObject.SelectedTemplateID,
                Miscellaneous1: submitAddressObject.AddressMiscellaneous1,
                Miscellaneous2: submitAddressObject.AddressMiscellaneous2,
                Miscellaneous3: submitAddressObject.AddressMiscellaneous3,
                HTMLValue: submitAddressObject.AddressHtmlValue,
                TextValue: submitAddressObject.AddressTextValue,
                EffectiveFrom: submitAddressObject.EffectiveFrom,
                EffectiveTo: submitAddressObject.EffectiveTo,
                DoNotContact: submitAddressObject.DoNotContact,
                NoContactReasonID: submitAddressObject.NoContactReasonID,
                ID: submitAddressObject.AddressID,
                GID: submitAddressObject.AddressGID,
                Address1: submitAddressObject.AddressAddressLine1,
                Address2: submitAddressObject.AddressAddressLine2,
                Address3: submitAddressObject.AddressAddressLine3,
                AssociationIDs: assocIDs
            };
            var customData = {
                data: data,
                submitAddressObject: submitAddressObject
            }

            sm.portal.vm.custom.callCustomization('UpdateATOMailingData', customData);
            return data;
        };
        this.Reset = function () {
            this.AddressID(0);
            this.AddressGID('');

            this.AddressUnitNumber('');
            this.AddressFloor('');
            this.AddressBuildingName('');
            this.AddressStreetNumber('');
            this.AddressStreetAddress('');
            this.AddressStreetName('');
            this.AddressStreetDirection('');
            this.AddressStreetSuffixName('');
            this.AddressPostOfficeBoxNumber('');
            this.AddressMunicipality('');
            this.AddressGoverningDistrictName('');
            this.AddressStreetSuffixID(0);
            this.AddressGoverningDistrictID(0);
            this.AddressCity('');
            this.AddressCounty('');
            this.AddressCareOf('');
            this.AddressMiscellaneous1('');
            this.AddressMiscellaneous2('');
            this.AddressMiscellaneous3('');
            this.AddressPostalCode('');
            this.AddressCountryID(0);
            this.AddressTemplateID(0);

            this.AddressAddressLine1('');
            this.AddressAddressLine2('');
            this.AddressAddressLine3('');

            this.AddressMiscellaneous1('');
            this.AddressMiscellaneous2('');
            this.AddressMiscellaneous3('');

            this.AddressHtmlValue('');
            this.AddressTextValue('');

            this.SelectedCountryID(undefined);
            this.SelectedTemplateID(undefined);
            this.SelectedTemplate(undefined);

            this.EffectiveFrom('');
            this.EffectiveTo('');
            this.DoNotContact(false);
            this.NoContactReasonID(undefined);
        };
        
        sm.portal.vm.custom.callCustomization('UpdateIsPostCodeRequired',self);

        sm.portal.vm.custom.callCustomization('OverrideMailingAddressValidation',self)
        /*** VALIDATION METHODS ***/
        this.SelectedCountryID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FullObjectValidation();
                }
            }
        });
        this.SelectedTemplateID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FullObjectValidation();
                }
            }
        });
        this.AddressAddressLine1.extend({
            maxLength: {
                params: 80,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '80')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.AddressLine1');
                }
            }
        });
        this.AddressAddressLine2.extend({
            maxLength: {
                params: 80,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '80')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.AddressLine2');
                }
            }
        });
        this.AddressAddressLine3.extend({
            maxLength: {
                params: 80,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '80')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.AddressLine3');
                }
            }
        });
        this.AddressBuildingName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.BuildingName');
                }
            }
        });
        this.AddressCareOf.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.CareOf');
                }
            }
        });
        this.AddressCity.extend({
            maxLength: {
                params: 60,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '60')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.City');
                }
            }
        });
        this.AddressCounty.extend({
            maxLength: {
                params: 60,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '60')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.County');
                }
            }
        });
        this.AddressCountryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return sm.portal.utility.isNullOrEmpty(self.SelectedCountryID()) && self.FieldTypeRequiredForTemplate('MailingAddressFieldType.CountryID');
                }
            }
        });
        this.AddressFloor.extend({
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.Floor');
                }
            }
        });
        this.AddressGoverningDistrictID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return (sm.portal.utility.isNullOrEmpty(self.AddressGoverningDistrictName()) || !self.AddressGoverningDistrictName.isValid()) && self.FieldTypeRequiredForTemplate('MailingAddressFieldType.GoverningDistrictID');
                }
            }
        });
        this.AddressGoverningDistrictName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return (sm.portal.utility.isNullOrEmpty(self.AddressGoverningDistrictID()) || !self.AddressGoverningDistrictID.isValid()) && self.FieldTypeRequiredForTemplate('MailingAddressFieldType.GoverningDistrictName');
                }
            }
        });
        this.AddressMiscellaneous1.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.Miscellaneous1');
                }
            }
        });
        this.AddressMiscellaneous2.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.Miscellaneous2');
                }
            }
        });
        this.AddressMiscellaneous3.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.Miscellaneous3');
                }
            }
        });
        this.AddressMunicipality.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.Municipality');
                }
            }
        });
        this.AddressPostalCode.extend({
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            },
            numericOrAlphanumerica: {
                params: { SelectedCountryGID: self.SelectedCountryGID }
            },
            ukPostcode: {
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.PostalCode') && (!sm.portal.utility.isNullOrEmpty(self.SelectedCountryText())) &&
                        (self.SelectedCountryText().toLowerCase() == 'united kingdom' ||
                            self.SelectedCountryText().toLowerCase() == 'england' ||
                            self.SelectedCountryText().toLowerCase() == 'scotland' ||
                            self.SelectedCountryText().toLowerCase() == 'wales' ||
                            self.SelectedCountryText().toLowerCase() == 'northern ireland' ||
                            self.SelectedCountryText().toLowerCase() == 'united kingdom, not otherwise specified');
                }
            },
            iePostcode: {
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.PostalCode') && (!sm.portal.utility.isNullOrEmpty(self.SelectedCountryText())) &&
                        (self.SelectedCountryText().toLowerCase() == 'ireland');
                }
            },
            caPostcode: {
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.PostalCode') && (!sm.portal.utility.isNullOrEmpty(self.SelectedCountryText())) &&
                        (self.SelectedCountryText().toLowerCase() == 'canada');
                }
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.PostalCode');
                }
            }
        });
        this.AddressPostOfficeBoxNumber.extend({
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.PostOfficeBoxNumber');
                }
            }
        });
        this.AddressStreetDirection.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.StreetDirection');
                }
            }
        });
        this.AddressStreetName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.StreetName');
                }
            }
        });
        this.AddressStreetAddress.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.StreetAddress');
                }
            }
        });
        this.AddressStreetNumber.extend({
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.StreetNumber');
                }
            }
        });
        this.AddressStreetSuffixID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return (sm.portal.utility.isNullOrEmpty(self.AddressStreetSuffixName()) || !self.AddressStreetSuffixName.isValid()) && self.FieldTypeRequiredForTemplate('MailingAddressFieldType.StreetSuffixID');
                }
            }
        });
        this.AddressStreetSuffixName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return (sm.portal.utility.isNullOrEmpty(self.AddressStreetSuffixID()) || !self.AddressStreetSuffixID.isValid()) && self.FieldTypeRequiredForTemplate('MailingAddressFieldType.StreetSuffixName');
                }
            }
        });
        this.AddressUnitNumber.extend({
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.FieldTypeRequiredForTemplate('MailingAddressFieldType.UnitNumber');
                }
            }
        });

        this.ModelErrors = ko.validation.group(this);
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {
            var isCompleted = this.IsVMValid();
            return isCompleted;

        }, this);
        /*** VALIDATION METHODS ***/

        return self;
    }

    $.extend(true, sm.portal.vm, {
        MailingAddressViewModel: MailingAddressViewModel
    });

})(jQuery);